// extracted by mini-css-extract-plugin
module.exports = {"reset":"g2_g3","button":"g2_es g2_g3","primary":"g2_g4 g2_es g2_g3","small":"g2_g5","secondary":"g2_g6 g2_es g2_g3"};